import React, { Component, useState } from 'react';
import { Badge, Card, CardBody } from 'reactstrap';

import Wizard from '../Wizard/Wizard';
import Logic from './../../Logic';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Step7 from './Step7';
import Step8 from './Step8';
import Step9 from './Step9';
import Step10 from './Step10';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const PersonalDetails = (props) => {
  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(9);
  const [stateValues, setStateValues] = useState({});

  const onSubmit = (values, step) => {
    return props.onFormSubmitted(values, step);
  }

  function getInitialValue(){
    if(props.location && props.location.state){
      return props.location.state.candidate;
    }
    else if(props.candidate){ //for self service logged in users
      return props.candidate;
    }
  }

  const pageChanged = (current, total) => {
    setCurrentPage(current);
    setTotalPages(total);
  }

  const labels = {
    required: 'שדה חובה',
    invalidDate: 'תאריך בפורמט שגוי, נדרש dd/MM/yyyy',
    invalidIdentityNumber: 'מספר תעודת זהות אינו תקין',
    invalidEmail: 'דואר אלקטרוני אינו תקין',
    invalidMobile: 'מספר טלפון אינו תקין',
    invalidZipCode: 'מיקוד צריך להיות מספר בין 5 או 7 ספרות',
    mustReadAndApproveManual: 'חובה עליך לקרוא את העלון לנבדק ולאשר אותו',
    mustReadAndApproveMedicalWeaver:'חובה לאשר את כתב ויתור סודיות רפואית',
    mustReadAndApproveConfidentiality:'חובה לקרוא ולאשר את הצהרת הסודיות',
    mustReadAndApproveDrugs:'חובה לקרוא ולאשר את הצהרת השימוש בסמים',
    mustReadAndApproveCriminalRecord:'חובה לקרוא ולאשר את הצהרת גישה למרשם הפלילי',
    otherStreetRequired: 'במידה ושם הרחוב לא נמצא חובה לציינו תחת רחוב אחר',
    mustReadAndApproveConfirmation: 'חובה לאשר את ההצהרה'
  }

  //manual
  function validate1(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      return serverValidation;
    }

    const logic = new Logic();
    const errors = {};
    if(!values.isApproveManual){
      errors.isApproveManual = labels.mustReadAndApproveManual
    }
    logic.log(errors);
    return errors;
  }

  //personal details
  function validate2(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      return serverValidation;
    }

    const logic = new Logic();
    const errors = {};

    if(!values.identityNumber || values.identityNumber && values.identityNumber.trim() === ''){
      errors.identityNumber = labels.required;
    }

    if(values.identityNumber && !logic.validateIdentityNumber(values.identityNumber)){
      errors.identityNumber = labels.invalidIdentityNumber;
    }

    if(!values.firstName || values.firstName && values.firstName.trim() === ''){
      errors.firstName = labels.required;
    }

    if(!values.lastName || values.lastName && values.lastName.trim() === ''){
      errors.lastName = labels.required;
    }

    if(!values.fatherName || values.fatherName && values.fatherName.trim() === ''){
      errors.fatherName = labels.required;
    }
    
    if(!values.birthDate){
      errors.birthDate = labels.required;
    }

    if(values.birthDate && !logic.validateDate(values.birthDate)){
      errors.birthDate = labels.invalidDate;
    }

    if(values.aliyaDate && !logic.validateDate(values.aliyaDate)){
      errors.aliyaDate = labels.invalidDate;
    }

    if(!values.genderId || values.genderId === 0){
      errors.genderId = labels.required;
    }

    if(!values.familyStatusId || values.familyStatusId < 1){
      errors.familyStatusId = labels.required;
    }

    if(values.familyStatusId === "5" && (!values.otherFamilyStatus || values.otherFamilyStatus.trim().length === 0)){
      errors.otherFamilyStatus = labels.required;
    }

    // if(!values.religionId || values.religionId === 0){
    //   errors.religionId = labels.required;
    // }

    if(!values.birthCountryId){
      errors.birthCountryId = labels.required;
    }

    if(!values.citizenships || values.citizenships && values.citizenships.trim() === ''){
      errors.citizenships = labels.required;
    }
    
    return errors;
  }

  //contact details
  function validate3(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      return serverValidation;
    }

    const logic = new Logic();
    const errors = {};

    if(!values.privateEmail || values.privateEmail && values.privateEmail.trim().length === 0){
      errors.privateEmail = labels.required;
    }

    if(values.privateEmail && (values.privateEmail.length < 8 || values.privateEmail.indexOf('@') === -1)){
      errors.privateEmail = labels.invalidEmail;
    }

    if(!values.mobilePhone || values.mobilePhone && values.mobilePhone.trim().length === 0){
      errors.mobilePhone = labels.required;
    }

    if(values.mobilePhone && values.mobilePhone.length < 9){
      errors.mobilePhone = labels.invalidMobile;
    }

    if(values.city){
      if(!values.city.Key){
        errors.city = labels.required;
      }
    }
    
    if(values.street){
      if(!values.street.Key){
        errors.street = labels.required;
      }

      if(values.street.Key && values.street.Key === -1 && !values.otherStreet){
        errors.otherStreet = labels.required;
        errors.street = labels.otherStreetRequired;
      }
    }
    
    if((values.zipCode) && (values.zipCode.trim().length !== 5 && values.zipCode.trim().length !== 7 && !isNaN(values.zipCode))){
      errors.zipCode = labels.invalidZipCode;
    }

    if(values.additionalCity && values.additionalCity.Key){

      if(!values.additionalStreet || !values.additionalStreet.Key){
        errors.additionalStreet = labels.required;
      }
  
      if(values.additionalStreet && values.additionalStreet.Key && values.additionalStreet.Key === -1 && !values.additionalOtherStreet){
        errors.additionalOtherStreet = labels.required;
        errors.additionalStreet = labels.otherStreetRequired;
      }

      if(!values.additionalHomeNumber){
        errors.additionalHomeNumber = labels.required;
      }

      if(!values.additionalZipCode){
        errors.additionalZipCode = labels.required;
      }

      if(values.additionalZipCode && (values.additionalZipCode.trim().length !== 5 && values.additionalZipCode.trim().length !== 7 && !isNaN(values.additionalZipCode))){
        errors.additionalZipCode = labels.invalidZipCode;
      }

    }

    // console.log(errors);
    return errors;
  }

  //medical
  function validate4(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      return serverValidation;
    }

    const logic = new Logic();
    const errors = {};
    if(!values.isApproveWaiverOfMedicalConfidentiality){
      errors.isApproveWaiverOfMedicalConfidentiality = labels.mustReadAndApproveMedicalWeaver;
    }

    return errors;
  }

  //confidentiality
  function validate5(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      return serverValidation;
    }

    const logic = new Logic();
    const errors = {};
    if(!values.isApproveConfidentiality){
      errors.isApproveConfidentiality = labels.mustReadAndApproveConfidentiality;
    }

    return errors;
  }

  //drugs
  function validate6(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      console.log(serverValidation);
      return serverValidation;
    }
    const logic = new Logic();
    const errors = {};
    if(!values.isApproveDrugs){
      errors.isApproveDrugs = labels.mustReadAndApproveDrugs;
    }
    logic.log(errors);
    return errors;
  }

  //criminal
  function validate7(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      return serverValidation;
    }
    const logic = new Logic();
    const errors = {};
    if(!values.isApproveCriminalRecord){
      errors.isApproveCriminalRecord = labels.mustReadAndApproveCriminalRecord;
    }

    return errors;
  }

  //uploads
  function validate8(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      return serverValidation;
    }
    const logic = new Logic();
    const errors = {};

    return errors;
  }

  //confirmation
  function validate9(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      return serverValidation;
    }
    const logic = new Logic();
    const errors = {};
    if(!values.isApproveDrugs){
      errors.finalConfirmation = labels.mustReadAndApproveConfirmation;
    }
    logic.log(errors);
    return errors;
  }

  //thanks
  function validate10(values, serverValidation){
    setStateValues(values);
    if(serverValidation){
      return serverValidation;
    }
    const logic = new Logic();
    const errors = {};

    return errors;
  }

  return (
  <div className="main-component-container">
    <Card>
      <CardBody>
        <div>
          <div>
            <h1>עריכת פרטי מועמד: {props.candidate.firstName} {props.candidate.lastName} <span style={{fontWeight:'100'}}> {props.candidate.identityNumber} </span></h1>
          </div>

          <Wizard 
            onSubmit={onSubmit} 
            initialValues={getInitialValue()} 
            onPageChange={pageChanged} 
            submitOnNext={true} 
            init={props.init} 
            serverValidation={true}
            nextButtonPrefix='שמור והמשך ל'
            nextButtonPostfix=' '
            prevButtonPrefix='חזור ל'
            prevButtonPostfix=' '
            {...props}
          >

            {/* Manual */}
            <Wizard.Page validate={(values,serverValidation) => validate1(values, serverValidation)} name="עלון לנבדק">
              <Step1 {...props} candidate={stateValues}/>
            </Wizard.Page>
            
            {/* Personal Details */}
            <Wizard.Page validate={(values,serverValidation) => validate2(values, serverValidation)} name="פרטים אישיים">
              <Step2 {...props} candidate={stateValues}/>
            </Wizard.Page> 

            {/* Contact details */}
            <Wizard.Page validate={(values,serverValidation) => validate3(values, serverValidation)} name="פרטי התקשרות">
              <Step3 {...props} candidate={stateValues}/>
            </Wizard.Page>

            {/* Medical */}
            <Wizard.Page validate={(values,serverValidation) => validate4(values, serverValidation)} name="הצהרת וויתור סודיות רפואית">
              <Step4 {...props} candidate={stateValues}/>
            </Wizard.Page>

            {/* Privacy */}
            <Wizard.Page validate={(values,serverValidation) => validate5(values, serverValidation)} name="הצהרת סודיות">
              <Step5 {...props} candidate={stateValues}/>
            </Wizard.Page>

            {/* Drugs */}
            <Wizard.Page validate={(values,serverValidation) => validate6(values, serverValidation)} name="הצהרת אי שימוש בסמים">
              <Step6 {...props} candidate={stateValues}/>
            </Wizard.Page>

            {/* Criminal */}
            <Wizard.Page validate={(values,serverValidation) => validate7(values, serverValidation)} name="הצהרת מתן גישה למרשם הפלילי">
              <Step7 {...props} candidate={stateValues}/>
            </Wizard.Page>

            {/* uploads */}
            {/* <Wizard.Page validate={(values,serverValidation) => validate8(values, serverValidation)} name="העלאת צרופות">
              <Step8 {...props} candidate={stateValues}/>
            </Wizard.Page> */}

            {/* confirmation */}
            <Wizard.Page validate={(values,serverValidation) => validate9(values, serverValidation)} name="אישור ההצהרות">
              <Step9 {...props} candidate={stateValues}/>
            </Wizard.Page>

            {/* Thanks */}
            <Wizard.Page validate={(values,serverValidation) => validate10(values, serverValidation)} name="סיום">
              <Step10 {...props} candidate={stateValues}/>
            </Wizard.Page>

          </Wizard>

        </div>

      </CardBody>

    </Card>
  </div>);
};

export default PersonalDetails;